import { BaseModel } from "../BaseModel";
import { BaseFindResult } from "../BaseFindResult";
import { TherapistStatusHistoryModel } from "./TherapistStatusHistoryModel";

export class TherapistStatusHistoryFindResultModel extends BaseFindResult {

    public getDataItem(i: number): TherapistStatusHistoryModel {
        let o: TherapistStatusHistoryModel = Object.assign(new TherapistStatusHistoryModel(), this.data[i]);
        return o;
    }

    public get dataTyped(): TherapistStatusHistoryModel[] {

        let d: TherapistStatusHistoryModel[] = [];

        for (var i = 0; i < this.data.length; i++) {
            d.push(this.getDataItem(i));
        }
        return d;
    }

    public override assignObjects(): void {
        super.assignObjects();

        for (var i = 0; i < this.data.length; i++) {
            let o: TherapistStatusHistoryModel = Object.assign(new TherapistStatusHistoryModel(), this.data[i]);
            this.data[i] = o;
        }
    }

}
